import images from "../../assets/images/assets";
import PaginationButton from "../SmallComponents/PaginationButton";
import PropTypes from "prop-types";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 4;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <PaginationButton
          key={i}
          pageNum={i.toString()}
          isActive={i === currentPage}
          onClick={() => handlePageChange(i)}
        />
      );
    }

    return pages;
  };

  return (
    <div className="pagenav py-8 w-full flex justify-center">
      <div className="centered-row gap-4">
        <div
          className="p-4 cursor-pointer"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <img
            src={images.arrow}
            alt="arrow-left"
            className={`w-6 ${
              currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
            }`}
          />
        </div>
        <div className="numbers centered-row gap-4 min-w-fit font-semibold">
          {renderPageNumbers()}
        </div>
        <div
          className="p-4 cursor-pointer"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          <img
            src={images.arrow}
            alt="arrow-right"
            className={`w-6 mirror-x ${
              currentPage === totalPages ? "opacity-50 cursor-not-allowed" : ""
            }`}
          />
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
